import Spacings from '@dynatrace/strato-design-tokens/spacings';

import { type Components } from '../../../core/types/markdown/react-markdown.js';
import type { SimpleTableColumnDef } from '../../../tables/SimpleTable/public.api.js';
import { SimpleTable } from '../../../tables/SimpleTable/SimpleTable.js';
import { getChildren, getTextAlignment } from '../utils.js';

export const tableMappings: Components = {
  table: ({ children, ...props }) => {
    if (children.length === 0) {
      return null;
    }

    // map thead>tr>td to columns
    const tHead = children[0];
    const tHeadRow = getChildren(tHead)[0];
    const columns: SimpleTableColumnDef<(typeof data)[number]>[] = getChildren(
      tHeadRow,
    ).map((cell, index) => ({
      header: () => <>{getChildren(cell)}</>,
      // oxlint-disable-next-line react/jsx-no-useless-fragment
      cell: ({ value }) => <>{value}</>,
      accessor: String(index),
      id: String(index),
      alignment: getTextAlignment(cell),
    }));

    // map tbody>tr>td to data
    const tBody = children[1];
    const data = getChildren(tBody).map((row) => ({
      ...getChildren(row).map((cell) => getChildren(cell)),
    }));

    return (
      <div {...props}>
        <SimpleTable
          style={{
            marginTop: Spacings.Size24,
            marginBottom: Spacings.Size24,
          }}
          columns={columns}
          data={data}
          variant={{
            contained: true,
            verticalDividers: true,
            rowDensity: 'default',
          }}
        />
      </div>
    );
  },
};
